var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_7437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4751 49.1375H11.3188C10.1005 49.1375 8.93208 48.6365 8.07058 47.745C7.20907 46.8533 6.7251 45.6439 6.7251 44.3831",
    stroke: "#A2A5F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1001 4.76245H12.8501C11.2256 4.76245 9.66773 5.43034 8.51907 6.61919C7.37041 7.80804 6.7251 9.42046 6.7251 11.1017V44.383C6.7251 43.1221 7.20907 41.9128 8.07058 41.0211C8.93208 40.1296 10.1005 39.6286 11.3188 39.6286H41.9438C42.3499 39.6286 42.7395 39.4616 43.0265 39.1643C43.3138 38.8672 43.4751 38.464 43.4751 38.0437V6.34727C43.4751 5.92696 43.3138 5.52384 43.0265 5.22664C42.7395 4.92943 42.3499 4.76245 41.9438 4.76245H37.3501",
    stroke: "#A2A5F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4131 49.1374V39.6284",
    stroke: "#A2A5F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3501 26.9499L31.2251 20.6107L25.1001 26.9499V4.76242C25.1001 3.92179 25.4227 3.11556 25.997 2.52114C26.5713 1.92672 27.3504 1.59277 28.1626 1.59277H34.2876C35.0998 1.59277 35.8789 1.92672 36.4532 2.52114C37.0275 3.11556 37.3501 3.92179 37.3501 4.76242V26.9499Z",
    stroke: "#A2A5F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_7437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 50.7144,
    fill: "white",
    transform: "translate(0.600098 0.00805664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.cccb9a18e54ed622e59763fbc28f504e.svg";
export { ForwardRef as ReactComponent };